export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14212.5642d0df.jpg";